import chat1Av from "../assets/direct/chat1.png";
import av7 from "../assets/direct/av-fallback-7.jpg";
import av3 from "../assets/direct/av-fallback-3.jpg";
import chat2Av from "../assets/direct/chat2.png";
import chat3Av from "../assets/direct/chat3.png";

export const CHAT_DATA = {
  chat1: {
    name: "Jo*****",
    avatar: chat1Av,
    username: "jo.silva"
  },
  chat2: {
    name: "Mel*****",
    avatar: av7,
    username: "mel.santos"
  },
  chat3: {
    name: "Ped*****",
    avatar: av3,
    username: "pedro_costa"
  },
  chat4: {
    name: "And*****",
    avatar: chat2Av,
    username: "andressa.lima"
  },
  chat5: {
    name: "𝕭𝖗𝖚****",
    avatar: chat3Av,
    username: "bruna.martins"
  }
};
